function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M267.82,255.277a1.29,1.29,0,0,1,0,1.825l-8.657,8.657a1.291,1.291,0,0,1-1.825,0l-4.121-4.121a1.29,1.29,0,1,1,1.825-1.825l3.209,3.209,7.745-7.745a1.291,1.291,0,0,1,1.825,0Zm9.216,5.241A16.518,16.518,0,1,1,260.518,244a16.509,16.509,0,0,1,16.518,16.518Zm-2.581,0a13.937,13.937,0,1,0-13.937,13.937,13.929,13.929,0,0,0,13.937-13.937Zm0,0",
  transform: "translate(-244 -244)"
});

function SvgIconCircularCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.036,
    height: 33.036,
    viewBox: "0 0 33.036 33.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircularCheck);
export default __webpack_public_path__ + "static/media/icon-circular-check.ca56fb77.svg";
export { ForwardRef as ReactComponent };